import React, { useState } from "react";
import classes from "./SubscribePage.module.css";

const SubscribePage = () => {
  const [msisdn, setMsisdn] = useState("");
  const [otp, setOtp] = useState("");
  const [token, setToken] = useState("");
  const [price, setPrice] = useState("");
  const [txId] = useState(Date.now().toString());
  const [step, setStep] = useState(1);
  const [message, setMessage] = useState("");

  const BASE_URL = "http://172.16.203.91:7070";

  const sendOtpHandler = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/otpBillingmaldeevsOoredoo/request/sendotp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic b25lOTc6b25lOTdAdGVzdDEyMw==",
          },
          body: JSON.stringify({
            msisdn: `960${msisdn}`,
            packName: "GLOBNEWS",
            channel: "PAYTM",
            tx_id: txId,
            subscription: "yes",
          }),
        }
      );

      const data = await response.json();

      if (data.statusCode === "200") {
        setToken(data.accessToken);
        setPrice(data.price);
        setStep(2);
        setMessage("OTP Sent Successfully");
      } else {
        setMessage(data.statusDescription);
      }
    } catch (error) {
      setMessage("Something went wrong.");
    }
  };

  const validateOtpHandler = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/otpBillingmaldeevsOoredoo/request/validate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic b25lOTc6b25lOTdAdGVzdDEyMw==",
          },
          body: JSON.stringify({
            msisdn: `960${msisdn}`,
            packName: "GLOBNEWS",
            channel: "PAYTM",
            tx_id: txId,
            token: token,
            price: price,
            subscription: "yes",
            otpString: otp,
          }),
        }
      );

      const data = await response.json();

      if (data.statusCode === "200") {
        setMessage("Subscription Successful 🎉");
      } else {
        setMessage(data.statusDescription);
      }
    } catch (error) {
      setMessage("Validation Failed.");
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <h2 className={classes.title}>Subscribe to Service</h2>

        {step === 1 && (
          <>
            <input
              type="text"
              placeholder="Enter Mobile Number"
              value={msisdn}
              onChange={(e) => setMsisdn(e.target.value)}
              className={classes.input}
            />
            <button onClick={sendOtpHandler} className={classes.button}>
              Send OTP
            </button>
          </>
        )}

        {step === 2 && (
          <>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className={classes.input}
            />
            <button onClick={validateOtpHandler} className={classes.button}>
              Validate & Subscribe
            </button>
          </>
        )}

        {message && <p className={classes.message}>{message}</p>}
      </div>
    </div>
  );
};

export default SubscribePage;
